import { action, makeObservable, observable } from 'mobx';

import { IApiClient } from '../../../../data/client';
import { GenerateEan13CodeCommand } from '../../../../data/model';
import { AsyncCommand } from '../../../../shared/common';

export class Ean13CodeShareState {
  private configurationCode: string = '';
  @observable public ean13code: string = '';

  public generateEan13CodeCommand: AsyncCommand;

  constructor(private readonly client: IApiClient) {
    this.generateEan13CodeCommand = new AsyncCommand(() => this.generateEan13Code());
    makeObservable(this);
  }

  private async generateEan13Code(): Promise<void> {
    const response = await this.client.send(
      new GenerateEan13CodeCommand({ configurationCode: this.configurationCode }),
    );
    this.setEan13Code(response.ean13Code);
  }

  @action
  public setEan13Code(ean13code: string): void {
    this.ean13code = ean13code;
  }

  @action
  public setConfigurationCode(configurationCode: string): void {
    this.configurationCode = configurationCode;
    this.ean13code = '';
  }
}
